import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled';

export const Paper = styled(Box)`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 16px;
  border-radius: 8px;
  font-size: 14px;
`;
